import { wikiToPlainText } from '@/util/tokenize_wiki_text'

export function composeGoalText(sections) {
  return sections.map(({ label, text }) => `**${label}**\n\n${text}`).join('\n\n')
}

export function goalSectionsPlainText(sections) {
  return sections.map(({ label, text }) => `${label}\n${wikiToPlainText(text)}`).join('\n\n')
}

export function groupSentences(sections) {
  const textsByGroup = new Map()
  sections
    .filter(section => section.group)
    .forEach(({ group, text }) => {
      textsByGroup.set(group, [...(textsByGroup.get(group) || []), wikiToPlainText(text)])
    })
  return [...textsByGroup].map(([label, texts]) => ({ label, text: texts.join(' ') }))
}

const DEFAULT_GOAL_SECTIONS_LAYOUT = 'stacked'

export function goalSectionsLayout(format) {
  return (format && format.layout) || DEFAULT_GOAL_SECTIONS_LAYOUT
}

export function goalSectionsPayload(sections, format) {
  return sections ? { goal_sections: sections, goal_format: format } : {}
}

export function replaceSectionText(sections, key, text) {
  return sections.map(section => (section.key === key ? { ...section, text } : section))
}
